import {
  GEOJSON_FILE_EXTENSION,
  HALO_ANNOTATIONS_FILE_EXTENSION,
  IMAGE_SCOPE_ANNOTATIONS_FILE_EXTENSION,
} from 'components/ImageViewer/constants';
import { CloudUploadOutlined } from '@mui/icons-material';
import { DATA_MANAGEMENT_BLUE } from 'utilities/colors';
import { Box, Typography } from '@mui/material';
import Dropzone from 'react-dropzone';
import React from 'react';

export const AnnotationsDropZone = ({
  classes,
  selectedProvider,
  onAddToUpload,
  isBatch,
}) => (
  <Dropzone
    disabled={!selectedProvider}
    onDrop={onAddToUpload}
    accept={[
      GEOJSON_FILE_EXTENSION,
      HALO_ANNOTATIONS_FILE_EXTENSION,
      IMAGE_SCOPE_ANNOTATIONS_FILE_EXTENSION,
    ]}
    maxFiles={isBatch ? 10 : 1}
  >
    {({ getRootProps, getInputProps }) => (
      <div
        {...getRootProps()}
        className={`${classes.dropzone} ${
          !selectedProvider && classes.dropzoneDisabled
        }`}
      >
        <input {...getInputProps()} />
        <CloudUploadOutlined sx={{ color: DATA_MANAGEMENT_BLUE }} />
        <Box display="flex">
          <Typography lineHeight={2}>Drag and drop or</Typography>
          <Typography lineHeight={2} className={classes.underline}>
            Click to upload
          </Typography>
        </Box>
        <Typography>Supported Formats: .geojson, .annotations, .xml</Typography>
      </div>
    )}
  </Dropzone>
);
